<template>
    <div>
        <div class="container h-100">
            <div class="d-flex justify-content-center h-100 valign">
                <!-- <div class="d-flex justify-content-center">
                    <div class="brand_logo_container_top">
                        <img src="~@/assets/images/logo-new.png" class="brand_logo_top" alt="Logo">
                    </div>
                </div> -->
                <div class="user_card" style="box-shadow: none;width: 500px;">
                    <div class="d-flex justify-content-center">
                        <div class="brand_logo_container">
                            <img src="~@/assets/images/asani-logo-mini.png" class="brand_logo" alt="Logo">
                        </div>
                    </div>
                    <div class="d-flex justify-content-center form_container">
                        <form>
                            <div class="input-group mb-3" style="width: 350px;">
                                <div class="input-group mb-3">
                                <div class="input-group-append">
                                    <span class="input-group-text"><i class="fas fa-user"></i></span>
                                </div>
                                <input type="text" name="email" :disabled="true" class="form-control input_user" value="" placeholder="email" v-model="email">
                            </div>
                                <div class="input-group-append">
                                    <span class="input-group-text"><i class="fas fa-key"></i></span>
                                </div>
                                <input type="password" name="password1" class="form-control input_pass" value="" placeholder="Create a New Password" v-model="password1">
                            </div>
                            <div class="input-group mb-2">
                                <div class="input-group-append">
                                    <span class="input-group-text"><i class="fas fa-key"></i></span>
                                </div>
                                <input type="password" name="passwword2" class="form-control input_pass" value="" placeholder="Confirm your Password" v-model="password2" @keyup.enter="handleNewPassword">
                            </div>
                        </form>
                    </div>
                    <div class="d-flex justify-content-center mt-3 login_container">
                        <button type="button" name="button" class="btn login_btn" v-if="logining == 0" @click="handleSubmit">Change Password</button>
                        <button type="button" name="button" class="btn login_btn" v-else disabled=""><img src="~@/assets/images/load-button.gif"></button>
                    </div>
                    <div class="mt-4">
                    <div class="d-flex justify-content-center links">
                            <a @click="toLoginPage()" style="color: #007bff;cursor: pointer;">Back To Login Page</a>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import swal from 'sweetalert'
export default {
    name: 'Home',
    data() {
        return {
            email: '',
            code:'',
            password1: '',
            logining: 0,
            password2: ''
        }
    },
    methods: {
        toPage(e) {
                this.$router.push(e)
            },
            toLoginPage() {
                this.toPage('/')
            },
            validateEmail(email) {
                var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            validatePassword(pwd) {
                var re = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[.,:;#?!@$%^&*-]).*$/;
                return re.test(pwd);
            },
            handleSubmit(e) {
                this.logining = 1
                e.preventDefault()
                if (!this.validateEmail(this.email)) {
                    swal("Sorry", "Please check your email format", "error", {
                        button: "Ok",
                    })
                    this.logining = 0;
                } else if (this.password1.length<8) {
                    swal("Sorry", "The password entered must be at least 8 character", "error", {
                        button: "Ok",
                    })
                    this.logining = 0;
                }else if (!this.validatePassword(this.password1)) {
                    swal("Sorry", "Password requires 1 of each of the following: uppercase letter, lowercase letter, number, special character(ex: .,:#?!@$%^&*-)", "error", {
                        button: "Ok",
                    })
                    this.logining = 0;
                }else if (this.password1!=this.password2) {
                    swal("Sorry", "The password entered is different", "error", {
                        button: "Ok",
                    })
                    this.logining = 0;
                }else if (this.email.length > 0&&this.password1.length > 0&&this.password2.length > 0) {
                    this.$http.post(process.env.FORGOT_PASSWORD_CHANGE, {
                            email: this.email,
                            code:this.code,
                            password:this.password1
                        })
                        .then(response => {
                            this.logining = 0
                            if (response.data.status === 200) {
                                this.email = ""
                                this.$router.push({path:'/', query: {
                                        changePwd: true
                                      }
                                  })
                            } else {
                                swal("Sorry", response.data.message, "error", {
                                    button: "Ok",
                                })
                            }
                        })
                        .catch(error => {
                            console.error(error.response)
                            swal("Error", error.message, "error");
                        })
                } else {
                    swal("Sorry", "Field must be fill", "error", {
                        button: "Ok",
                    })
                    this.logining = 0;
                }
            },
            cekLogin() {
                if (localStorage.getItem('jwt') != null) {
                    this.$router.push('/home')
                }
            }
    },
    created() {
        this.cekLogin()
        $('.modal').modal('hide')
        this.email = this.$route.query.em
        this.code = this.$route.query.code

    }
}
</script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
    /* Coded with love by Mutiullah Samim */
    body,
    html {
      margin: 0;
      padding: 0;
      height: 100%;
      background: #60a3bc !important;
    }
    .user_card {
      height: 400px;
      width: 350px;
      margin-top: auto;
      margin-bottom: auto;
      background: #F8F9FA;
      position: relative;
      display: flex;
      justify-content: center;
      flex-direction: column;
      padding: 10px;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
      -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
      -moz-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
      border-radius: 5px;

    }

    .brand_logo_container_top {
      margin-top: 110px;
      margin-right: 50px;
    }

    .brand_logo_container {
      position: absolute;
      height: 170px;
      width: 170px;
      top: -75px;
      border-radius: 50%;
      background: #fff;
      padding: 10px;
      text-align: center;
    }
    .brand_logo {
      height: 150px;
      width: 150px;
      border-radius: 50%;
      border: 2px solid white;
    }
    .form_container {
      margin-top: 100px;
    }
    .login_btn {
      width: 100%;
      background: #2797FB !important;
      color: white !important;
    }
    .login_btn:focus {
      box-shadow: none !important;
      outline: 0px !important;
    }
    .login_container {
      padding: 0 2rem;
    }
    .input-group-text {
      background: #2797FB !important;
      color: white !important;
      border: 0 !important;
      border-radius: 0.25rem 0 0 0.25rem !important;
    }
    .input_user,
    .input_pass:focus {
      box-shadow: none !important;
      outline: 0px !important;
    }
    .custom-checkbox .custom-control-input:checked~.custom-control-label::before {
      background-color: #c0392b !important;
    }

    .valign{
      vertical-align: middle;
      margin: 150px 0px;
    }

    .brand_logo_container_top {
      margin-top: 110px;
      margin-right: 50px;
    }

    @media(max-width: 991px){
      .brand_logo_container_top {
      margin-top: 110px;
      margin-right: 50px;
      display: none;
    }
    }
</style>



// WEBPACK FOOTER //
// src/components/ForgotPasswordPage.vue